// src/store/rtkqBridge.js
import { store } from "../Redux/store";
import { setupApi } from "./setupApi";
import { accountApi } from "./accountApi";
import { giftcardsApi } from "./giftcardsApi";

const normalizePath = (endpoint) => {
  try {
    if (/^https?:\/\//i.test(endpoint)) {
      return new URL(endpoint).pathname.replace(/^\/+/, "").toLowerCase();
    }
  } catch {}
  const base = (window.baseDomain || "").replace(/^\/+|\/+$/g, "");
  return endpoint.replace(base, "").replace(/^\/+/, "").toLowerCase();
};

// treat both new "opening-hours-*" and any legacy "openinghours" variants as opening hours
const isOpeningHoursPath = (p) =>
  p.startsWith("api/opening-hours") ||
  p.includes("opening-hours") ||
  p.includes("openinghours");

export const invalidateFor = (endpoint) => {
  const d = store.dispatch;
  const p = normalizePath(endpoint);

  // These tags are provided by the single getRestaurantSetup query,
  // so invalidating them will cause the one cache to refetch when needed.
  if (isOpeningHoursPath(p)) {
    d(setupApi.util.invalidateTags(["OpeningHours"]));
  }
  if (p.startsWith("api/exceptions")) {
    d(setupApi.util.invalidateTags(["Exceptions"]));
  }
  if (p.startsWith("api/settings")) {
    d(setupApi.util.invalidateTags(["Settings"]));
  }
  if (p.startsWith("api/account")) {
    d(accountApi.util.invalidateTags(["Account"]));
  }
  if (p.startsWith("api/giftcards")) {
    d(giftcardsApi.util.invalidateTags(["Giftcards"]));
  }
};

// Optional: warm the one setup cache (useful right after a mutation)
export const prefetchSetup = (force = true) => {
  const d = store.dispatch;
  d(setupApi.util.prefetch("getRestaurantSetup", undefined, { force }));
};
